var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitLHCO('formlhco')
      }
    }
  }, [_c('legend', [_vm._v("Coloader Shifting Process")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Source Hub Name "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>",
      "right": _vm.hubright
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "data-vv-scope": "formlhco",
      "options": _vm.hubNameOptList,
      "selected-option": _vm.selectedObjHubName,
      "name": "hubName",
      "placeholder": "Select Hub Name",
      "isDisabled": ""
    },
    model: {
      value: (_vm.hubName),
      callback: function($$v) {
        _vm.hubName = $$v
      },
      expression: "hubName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('formlhco.hubName')),
      expression: "errors.has('formlhco.hubName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Hub Name field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Route Mode "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeMode),
      expression: "routeMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "data-vv-scope": "formlhco",
      "name": "routeMode"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.routeMode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Route Mode")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Surface"
    }
  }, [_vm._v("Surface")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Air"
    }
  }, [_vm._v("Air")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Train"
    }
  }, [_vm._v("Train")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('formlhco.routeMode')),
      expression: "errors.has('formlhco.routeMode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Route Mode field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("From / To Date "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    attrs: {
      "data-vv-scope": "formlhco",
      "range": "",
      "lang": "en",
      "name": "Date",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.fromToDate),
      callback: function($$v) {
        _vm.fromToDate = $$v
      },
      expression: "fromToDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('formlhco.Date')),
      expression: "errors.has('formlhco.Date')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Date field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Invoice No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inVoiceNo),
      expression: "inVoiceNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Invoice No",
      "name": "inVoiceNo",
      "id": "inVoiceNo"
    },
    domProps: {
      "value": (_vm.inVoiceNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inVoiceNo = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Show")]), _vm._v(" \n                "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetFormCSP
    }
  }, [_vm._v(" Reset")])])], 1)])])])], 1)]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Scheduled Connection")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Invoice No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Connection Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Route Mode")]), _vm._v(" "), (_vm.routeMode == 'Surface') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("ETA/ETD")]) : _vm._e(), _vm._v(" "), (_vm.routeMode != 'Surface') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Train/Flight Name")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Coloader Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Line Haul Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Total Bags")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Total Line Haul Bags")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.scheduledConnection), function(data, index) {
    return (_vm.scheduledConnection.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          return _vm.editScheduledConnection(data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o fa-lg"
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.invoiceno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), (_vm.routeMode == 'Surface') ? _c('td', {
      staticClass: "text-center",
      attrs: {
        "id": 'displayTFDtl' + data.lhtrainflightdetailsid + data.linehauldetailsid
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "title": "View Train/Flight Details"
      },
      on: {
        "click": function($event) {
          return _vm.getTrainFlightDetails(data.lhtrainflightdetailsid, data.linehauldetailsid)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg"
    })])]) : _vm._e(), _vm._v(" "), (_vm.routeMode != 'Surface') ? _c('td', {
      staticClass: "text-center",
      attrs: {
        "id": 'displayTFDtl' + data.lhtrainflightdetailsid + data.linehauldetailsid
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "title": "View Train/Flight Details"
      },
      on: {
        "click": function($event) {
          return _vm.getTrainFlightDetails(data.lhtrainflightdetailsid, data.linehauldetailsid)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg"
    })])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.coloadername))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.linehaulstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totalconnectedbags))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totallinehaulbags))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.scheduledConnection.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])], 1), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > 10),
      expression: "totalRows>10"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'pagination'
    }
  })], 1)], 1), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplayCDUpdate),
      expression: "isDisplayCDUpdate"
    }],
    staticStyle: {
      "width": "50%"
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitUpdateLHCO('updateForm')
      }
    }
  }, [_c('legend', [_vm._v("Update Coloader Details - "), _c('span', {
    staticClass: "bg-span"
  }, [_vm._v(_vm._s(_vm.invoiceNo))])]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Route Mode :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.updateCDObj.routeMode),
      expression: "updateCDObj.routeMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "data-vv-scope": "updateForm",
      "name": "routeModeCD"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.updateCDObj, "routeMode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.loadColoaders()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Route Mode")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Surface"
    }
  }, [_vm._v("Surface")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Air"
    }
  }, [_vm._v("Air")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Train"
    }
  }, [_vm._v("Train")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('updateForm.routeModeCD')),
      expression: "errors.has('updateForm.routeModeCD')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Route Mode field is required.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Coloader :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-users'></i>",
      "right": _vm.loaderCL
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.updateCDObj.coloader),
      expression: "updateCDObj.coloader"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "data-vv-scope": "updateForm",
      "name": "coloaderCD"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.updateCDObj, "coloader", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.loadTrainFlight()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Coloader")]), _vm._v(" "), _vm._l((_vm.coloaderArrayObj), function(coloader) {
    return _c('option', {
      domProps: {
        "value": coloader.ColoaderID
      }
    }, [_vm._v(_vm._s(coloader.ColoaderName))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('updateForm.coloaderCD')),
      expression: "errors.has('updateForm.coloaderCD')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Coloader field is required.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Train/Flight No. :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-train'></i>",
      "right": _vm.loaderTF
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.updateCDObj.trainFlight),
      expression: "updateCDObj.trainFlight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "data-vv-scope": "updateForm",
      "name": "trainFlightCD"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.updateCDObj, "trainFlight", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Train/Flight No.")]), _vm._v(" "), _vm._l((_vm.trainFlightArrayObj), function(obj) {
    return _c('option', {
      domProps: {
        "value": obj.LHTrainFlightDetailsID
      }
    }, [(_vm.updateCDObj.routeMode == 'Surface') ? _c('span', [_vm._v(_vm._s(obj.ETD) + " - " + _vm._s(obj.ETA))]) : _c('span', [_vm._v(_vm._s(obj.EntityName) + " - (" + _vm._s(obj.EntityNumber) + ")")])])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('updateForm.trainFlightCD')),
      expression: "errors.has('updateForm.trainFlightCD')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Train/Flight No. field is required.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Reason :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-comments'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.updateCDObj.reason),
      expression: "updateCDObj.reason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "data-vv-scope": "updateForm",
      "name": "reasonCD"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.updateCDObj, "reason", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Reason")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Change in RouteMode"
    }
  }, [_vm._v("Change in RouteMode")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Change in Coloader"
    }
  }, [_vm._v("Change in Coloader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Change in Train/Flight"
    }
  }, [_vm._v("Change in Train/Flight")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Changes in All"
    }
  }, [_vm._v("Changes in All")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('updateForm.reasonCD')),
      expression: "errors.has('updateForm.reasonCD')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Reason field is required.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "userfooter form-actions"
  }, [_c('button', {
    staticClass: "-common-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Update Details")]), _vm._v(" \n                "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelFormCDUP
    }
  }, [_vm._v(" Cancel")])])])])], 1)])]), _vm._v(" "), _c('label', {
    attrs: {
      "id": "UpdateLHCO"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07b6af2d","hasScoped":true}!./src/views/components/ShiftConnectionLHCO/ShiftConnectionLHCO.component.html
// module id = 901
// module chunks = 2